module.exports = __webpack_public_path__ + "static/home1-sidebar-banner1-34cdd2997ae6f68d40cee83d96e3c413.jpg";